import React from 'react';
import { AudioDeviceState } from './useAudioDeviceStateContext';

export default function useAudioDeviceAppState() {
  const [state, setState] = React.useState<AudioDeviceState | null>(null);

  React.useEffect(() => {
    if (!window.appStateAPI) return undefined;
    const port = window.appStateAPI.subscribeToStateChanges('audioDevice');
    port.addEventListener('message', (event: MessageEvent) => {
      const { data } = event;
      if (data.type === 'app-state-init' || data.type === 'app-state-update') {
        setState(data.payload as AudioDeviceState);
      }
    });
    port.start();
    return () => { port.close(); };
  }, []);

  const updateState = React.useCallback((newState: AudioDeviceState) => {
    window.appStateAPI?.updateState('audioDevice', newState);
  }, []);

  return { state, updateState };
}
